import tokens from '@lansforsakringar/core-tokens'
import { css } from 'lit'

import { vars, scoped, declare, override } from '#utils/styles'

const locals = scoped('form-textarea', [
	'background_color',
	'border_radius',
	'border_color',
	'padding',
	'height',
	'color'
] as const)

export default css`
	:host {
		${declare(locals, {
			background_color: tokens.color_background_secondary,
			border_radius: tokens.border_radius_xs,
			border_color: tokens.color_border_focus,
			padding: tokens.spacing_sm,
			height: tokens.spacing_4xl,
			color: tokens.color_text_primary
		})};

		display: flex;
		width: 100%;
		flex-direction: column;
		color: ${vars(locals.color)};

		&:has(.textarea:disabled) {
			${override(locals.color, tokens.color_text_disabled)};
		}
	}

	.label {
		padding-block-end: ${vars(tokens.spacing_xs)};
		font-size: 1rem;
		font-weight: normal;
		line-height: calc(19 / 16);
		text-wrap: balance;
	}

	.box {
		display: flex;
		align-items: center;
		overflow: hidden;
		background: ${vars(locals.background_color)};
		border-radius: ${vars(locals.border_radius)};
		border: 1px solid;
		color: ${vars(locals.color)};
		border-color: ${vars(locals.border_color)};
		transition: 125ms var(--ease-in);
		transition-property: box-shadow, border-color;

		/* Make the border gray when it's empty */
		&:has(.textarea:where(:placeholder-shown)) {
			${override(locals.border_color, tokens.color_border_tertiary)};
		}

		&:has(.textarea:where(:-webkit-autofill, :autofill)) {
			background: ${vars(tokens.color_background_highlight_primary)};
		}

		/* Focus and hover state */
		&:has(.textarea:where(:hover, :focus)) {
			${override(locals.border_color, tokens.color_border_focus)};

			box-shadow: inset 0 0 0 1px ${vars(locals.border_color)};
			transition-timing-function: var(--ease-out);
			outline: 0;
		}

		&.focus-visible:has(.textarea:focus-visible) {
			outline: var(--focus-outline);
			outline-offset: var(--focus-outline-offset);
		}

		/* Invalid state */
		&.invalid {
			${override(locals.border_color, tokens.color_border_error)};
		}

		/* Disabled state */
		&:has(.textarea:disabled) {
			${override(locals.border_color, tokens.color_border_disabled)};
			${override(locals.background_color, tokens.color_background_disabled)};

			box-shadow: none;
			transition-duration: 0ms;
		}
	}

	.textarea {
		flex: 1;
		padding: ${vars(locals.padding)};
		/* height: ${vars(locals.height)}; */
		border: none;
		font-size: 1rem;
		line-height: calc(21 / 16);
		caret-color: ${vars(tokens.color_border_focus)};
		color: inherit;
		appearance: none;
		background: transparent;
		resize: none;

		&:focus {
			outline: none;
		}
	}

	.textarea:is(:-webkit-autofill, :autofill) {
		background: transparent !important;
		color: inherit !important;
	}

	.footer {
		display: flex;
		justify-content: space-between;
		padding-block-start: ${vars(tokens.spacing_xs)};
		gap: 0 ${vars(tokens.spacing_sm)};

		&.wrap {
			flex-wrap: wrap;
		}
	}

	.help {
		cursor: default;
		font-size: 0.875rem;
		line-height: calc(18 / 14);
		color: ${vars(tokens.color_text_secondary)};

		&.counter {
			user-select: none;
			margin-left: auto;
		}

		&.warning {
			color: ${vars(tokens.color_text_error)};
		}
	}

	.validation {
		display: flex;
		align-items: flex-start;
		padding-block-start: ${vars(tokens.spacing_xs)};
		cursor: default;
		gap: ${vars(tokens.spacing_xs)};
		color: ${vars(tokens.color_text_error)};
		line-height: calc(18 / 14);
		font-size: 0.875rem;

		.footer.wrap & {
			width: 100%;
			order: 3;
		}

		.icon {
			margin: -0.2rem 0 0 -0.15rem;
		}
	}
`
